import request from '@/utils/request'

export function setIosShield(data) {
    return request({
        url: '/backend/manage/system/setIosShield',
        method: 'post',
        data: data
    })
}
export function decryptOperate(data) {
    return request({
        url: '/backend/manage/system/wechatOrder12Reset',
        method: 'post',
        data: data
    })
}